import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/copydata-folder.svg'


const _withScopeId = n => (_pushScopeId("data-v-084c8715"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "workstation-modal-body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workstation-modal-body__inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "workstation-modal-body__image" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Image",
      width: "87",
      height: "87"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h2", null, "Copy Data to Another Workstation"),
  /*#__PURE__*/_createElementVNode("p", null, "Ready to copy data?")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-dropdown__label" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Workstation")
], -1))
const _hoisted_4 = { class: "custom-dropdown__inner" }
const _hoisted_5 = { class: "custom-dropdown__menu" }
const _hoisted_6 = { class: "custom-dropdown__menu-inner" }
const _hoisted_7 = { class: "workstation-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!

  return (_openBlock(), _createBlock(_component_GeneralDialog, { onOnClose: $setup.onCloseImportWorkstationModal }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: _normalizeClass(["custom-dropdown", { 'is-open': $data.isOpen }])
        }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "custom-dropdown__trigger",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.isOpen = !$data.isOpen))
            }, [
              _createElementVNode("p", null, _toDisplayString($setup.selectedWorkStationName
                    ? $setup.selectedWorkStationName?.name
                    : "Select Your workstation "), 1),
              _createVNode(_component_v_icon, {
                icon: "mdi-chevron-down",
                color: "#0C0F4A"
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_radio_group, {
                  modelValue: $setup.selectedWorkStation,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedWorkStation) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userWorkstations, (workstation) => {
                      return (_openBlock(), _createBlock(_component_v_radio, {
                        color: "#4F55F0",
                        label: workstation.name,
                        value: workstation.id,
                        key: workstation.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ])
        ], 2)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_btn, {
          onClick: $setup.onCloseImportWorkstationModal,
          class: "button button-purple-border"
        }, {
          default: _withCtx(() => [
            _createTextVNode("CANCEl")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_btn, {
          class: "button button-orange",
          disabled: !$setup.selectedWorkStation,
          onClick: $setup.onClickContinue
        }, {
          default: _withCtx(() => [
            _createTextVNode("CONTINUE")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}